import type { PropCardMeta } from '@/types/reveal';
import { getPropCardHeadline } from '@/utils/propBasedDailyReveal';

type PropCardInfoProps = {
  prop: PropCardMeta;
  scale?: number;
  isLarge?: boolean;
  isDimmed?: boolean;
};

const druk = '"Druk Text Wide Trial", "Arial Black", sans-serif';

export function PropCardInfo({
  prop,
  scale = 1,
  isLarge = true,
  isDimmed = false,
}: PropCardInfoProps) {
  const headline = getPropCardHeadline(prop);
  if (!headline) return null;

  // Top headline — white type, no plate. Odds never shown.
  return (
    <div
      className={`flex w-full shrink-0 items-center justify-center px-[8px] ${
        isLarge ? 'h-[26px]' : 'h-[18px]'
      }`}
    >
      <span
        className={`truncate text-center uppercase leading-none tracking-wide ${
          isDimmed ? 'text-white/55' : 'text-white'
        }`}
        style={{
          fontFamily: druk,
          fontSize: `${(isLarge ? 11 : 8) * scale}px`,
          fontWeight: 900,
          letterSpacing: '0.02em',
        }}
      >
        {headline}
      </span>
    </div>
  );
}
